import { TranslateService } from '@ngx-translate/core';
import { User } from '../../features/admin/domain/models/user/user';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserUtils {
  protected translate = inject(TranslateService);
  mapUserStatus(isActive: boolean): string {
    if (isActive)
      return this.translate.instant('admin.users.statusOptions.active');
    return this.translate.instant('admin.users.statusOptions.disabled');
  }

  getGerberCount(user: User): number {
    return user.convertedFiles.filter((f) => f.fileType === 'Gerber').length;
  }

  getLectraCount(user: User): number {
    return user.convertedFiles.filter((f) => f.fileType === 'Lectra').length;
  }
}
